exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// C:/xampp2/htdocs/angular-front/node_modules/core-js/modules/_object-pie.js
// module id = ../../../../core-js/modules/_object-pie.js
// module chunks = polyfills